<template>
    <div class="tabs_content">
      <section>
        <div class="status">
          <h2>{{ title }}</h2>
          <a v-if="availableProtocols.length > 0 && isEditable" class="add add_expand"
             :class="{ open: this.addProtocolOpened }" @click.stop="toggleAddProtocol"
             :title="'Přidat protokol' | translate" v-translate>Přidat protokol</a>
        </div>

        <div class="filter expand_content" :class="{ open: addProtocolOpened }">
          <div class="field_left">
            <select-box id="protocol" v-model="selectedProtocol" :options="protocolOptions">
              <translate class="translate">Protokol</translate>
            </select-box>
          </div>

          <div class="field_right">
            <p class="field">
              <input class="btn" type="button" :value="'Přidat' | translate" @click.stop="addProtocol"/>
            </p>
          </div>
        </div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="device-profiles-protocols">
            <table class="vypis vypis_detail">
              <thead class="no_sortable"/>
              <tr>
                <th class="no_padding drag_drop"></th>
                <th class="no_padding_left"><span class="name" v-translate>Protokol</span></th>
                <th class="no_padding edit"></th>
              </tr>
              <tbody :class="{sortable: isEditable}">
              <tr v-for="idProtocol in protocolIds" :rowid="idProtocol" class="sorted_protocols"
                  :key="'protocol_' + idProtocol">
                <td class="no_padding drag_drop"><span></span></td>

                <td class="first_data no_padding_left" data-th="Protokol">{{ getProtocolName(idProtocol) }}</td>

                <td class="no_padding edit">
                  <div class="edit_inner" v-if="isEditable">
                    <a class="btn btn_action btn_delete" @click.stop="removeProtocol(idProtocol)"
                       :title="'Smazat' | translate" v-translate>Smazat</a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
</template>

<script>

export default {
    name: "Protocols",
    props: {
        title: String,
        protocolIds: Array,
        protocols: Array,
        isEditable: Boolean
    },
    data() {
        return {
            addProtocolOpened: false,
            selectedProtocol: null,
        }
    },
    mounted() {
        if (this.isEditable) {
            $(".sortable").sortable({
                stop: this._updateSortedProtocols
            });
        }
    },
    methods: {
        getProtocolName(idProtocol) {
            let protocol = this.protocols.find((protocol) => protocol.id == idProtocol);
            return protocol ? protocol.name : null;
        },
        removeProtocol(idProtocol) {
            this.$emit('removeProtocol', idProtocol);
        },
        toggleAddProtocol() {
            this.addProtocolOpened = !this.addProtocolOpened;
            if (this.addProtocolOpened) {
                this.selectedProtocol = this.availableProtocols[0].id;
            }
        },
        addProtocol() {
            this.$emit('addProtocol', ~~this.selectedProtocol);
        },
        _updateSortedProtocols() {
            const newProtocolSort = [];

            $(".sorted_protocols").each((el, x) => {
                newProtocolSort.push(~~$(x).attr('rowid'));
            });

            this.$emit('sortProtocols', newProtocolSort);
        }
    },
    computed: {
        availableProtocols() {
            let availableProtocols = this.protocols.filter((protocol) => !this.protocolIds.includes(protocol.id));

            if (availableProtocols.length > 0) {
                this.selectedProtocol = availableProtocols[0].id;
            } else {
                this.addProtocolOpened = false;
            }

            return availableProtocols;
        },
        protocolOptions() {
            return this._.map(this.availableProtocols, function (item) {
                return {id: item['id'], text: item['name']}
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/Protocols.vue